import React from 'react';
import styles from './Card.module.css';

export function Card({ as: As = 'div', interactive, className = '', children, ...rest }) {
  return (
    <As
      className={[styles.card, interactive ? styles.interactive : '', className].filter(Boolean).join(' ')}
      {...rest}
    >
      {children}
    </As>
  );
}

export function CardHeader({ title, subtitle, actions }) {
  return (
    <div className={styles.header}>
      <div className={styles.headerText}>
        {title ? <h3 className={styles.title}>{title}</h3> : null}
        {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
      </div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </div>
  );
}

export const CardBody = React.forwardRef(function CardBody({ className = '', children, ...rest }, ref) {
  return (
    <div ref={ref} className={[styles.body, className].filter(Boolean).join(' ')} {...rest}>
      {children}
    </div>
  );
});

CardBody.displayName = 'CardBody';

export function CardFooter({ children }) {
  return <div className={styles.footer}>{children}</div>;
}
